/**
 * Usage
 * import { openCustomModal, closeCustomModal } from "components/custom/modals";
 *
 * const mapStateToDispatch = dispatch => ({
 *     openCustomModal: bindActionCreators(openCustomModal, dispatch),
 *     closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
 * })
 *
 * Then use like this
 * const modalObj = {
      id: uniqId,
      header: "Confirm",
      children: <Content />,
      buttons: {
        accept: {
          text: "Accept",
          callback: onAccept
        },
        cancel: {
          text: "Cancel",
          callback: () => {}
        },
      },
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
 this.props.openCustomModal(modalObj);
 */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button } from "react-bootstrap";
import { Modal } from "antd";
import Draggable from "react-draggable";
import {
    CUSTOM_MODAL_CLOSE,
    CUSTOM_MODAL_OPEN
} from "reducers/customModalsReducer";

/* --- ACTIONS --- */
export const openCustomModal = (obj) => ({
    type: CUSTOM_MODAL_OPEN,
    obj,
});

export const closeCustomModal = (obj) => ({
    type: CUSTOM_MODAL_CLOSE,
    obj,
});

/* --- COMPONENTS --- */
const CustomModal = (props) => {
    const onHandleAccept = () => {
        if (props.item.onHide) {
            props.item.onHide();
        }

        const { buttons } = props.item;
        if (buttons.accept.callback) {
            buttons.accept.callback();
        }
    },
        onHandleCancel = () => {
            const { buttons } = props.item;
            if (buttons.cancel.callback) {
                buttons.cancel.callback();
            }

            if (props.item.onHide) {
                props.item.onHide();
            }
        };

    const {
        onHide,
        handleClose,
        header,
        children,
    } = props.item;
    const buttons = props.item.buttons || null;
    const modalSettings = props.item.modalSettings || {};

    let width =
        modalSettings.size && modalSettings.size === "sm" ? 520 : 900;
    if (modalSettings && modalSettings.style && modalSettings.style.width) {
        width = modalSettings.style.width;
    }

    return (
        <div className="global-modal-wrapper">
            <Modal
                visible={true}
                centered
                title={header}
                footer={null}
                maskClosable={false}
                afterClose={() => {
                    if (typeof onHide === "function") {
                        onHide();
                    }
                }}
                onCancel={() => {
                    if (typeof handleClose === "function") {
                        handleClose();
                    }
                }}
                width={width}
                {...modalSettings}
            >
                <Draggable
                    axis="both"
                    handle=".global-modal-wrapper"
                    position={null}
                    grid={[2, 2]}
                    scale={1}
                >
                    <div className="col-12">
                        <div>
                            {children}
                        </div>
                        {buttons ?
                            <div>
                                {buttons.accept ?
                                    <Button variant="primary" onClick={onHandleAccept}>
                                        {buttons.accept.text}
                                    </Button>
                                    : null}
                                {buttons.cancel ?
                                    <Button variant="secondary" onClick={onHandleCancel}>
                                        {buttons.cancel.text}
                                    </Button>
                                    : null}
                            </div>
                            : null}
                    </div>
                </Draggable>
            </Modal>
        </div>
    );
};

const Modals = (props) => props.customModals.modals.map((item, i) =>
    <CustomModal
        item={item}
        key={i}
    />);

const mapStateToProps = state => ({
    customModals: state.customModals
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

const ModalContainer = connect(mapStateToProps, mapStateToDispatch)(Modals);
export default ModalContainer;
